/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { useEffect, useState } from "react";
import {
  Box,
  FormControlLabel,
  Switch,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import {
  LuiToolbar,
  LuiObjectStatus,
  Alert,
  LuiSemanticIndicator
} from "@jda/lui-common-component-library-mui5";
import { Check, Error } from "@mui/icons-material";
import TableWithPaginator from "../../shared/tableWithPaginator";
import { LABELS, PAGE_OPTIONS } from "./constants";
import { useStyles } from "./styles";
import { getAllIdp, getBYDeliversIdp } from "../../store/realm/realm";
import { updateByIdpStatus } from "../../services/realm";
import {
  selectSelectedRealm,
  selectAllIdps,
  selectByIdpStatus,
} from "../../store/realm/realmSelector";
import useWindowDimensions from "../../shared/windowDimensions/windowDimensions";
const RealmIdps = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { height } = useWindowDimensions();

  const selectedRealm = useSelector(selectSelectedRealm);
  // const allIdps = useSelector(selectAllIdps);
  const byIdpStatus = useSelector(selectByIdpStatus);

  useEffect(() => {
    getBYDeliversIdp(dispatch);
  }, [dispatch]);

  useEffect(() => {
    getAllIdps();
  }, [selectedRealm.id]);

  const getAllIdps = () => {
    getAllIdp(dispatch);
  };
  const handleBySupportToggle = (
    _event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    console.log("By Support toggled: ", checked);
    updateByIdpStatus(checked);
  };
  const columns = [
    {
    accessorKey: 'priority',
    header: 'Priority',
    Cell: ({ cell }) => <LuiSemanticIndicator state={(cell.row.original.enabled? Alert.SUCCESS : Alert.ERROR)} height={40} thickness={4} />,
    size: 5,
    minSize: 5,
    maxSize: 5,
    enableColumnActions: false,
    muiTableBodyCellProps: {
      sx: {
        padding: 0,
      },
    },
    muiTableHeadCellProps: {
      sx: {
        padding: 0,
        maxWidth: '5px',
        '> *': {
          opacity: 0,
        },
      },
    },
  },
    {
      id: "idpName",
      accessorKey: LABELS.IDP_ID_FIELD,
      header: LABELS.IDP_TITLE,
    },
    {
      id: "type",
      accessorKey: LABELS.IDP_TYPE_FIELD,
      header: LABELS.IDP_TYPE_TITLE,
    },
    {
      id: "status",
      accessorKey: LABELS.IDP_STATUS_FIELD,
      header: LABELS.IDP_STATUS_TITLE,
      Cell: ({ cell }) => (cell.getValue() ? "Enabled" : "Disabled")
    }
  ];

  return (
    <Box height={height - 250}>
      <Box>
        <LuiToolbar
          className={classes.toolbar}
          rightZone={{
            component: (
              <>
                <Switch
                  inputProps={{ role: "switch" }}
                  color="primary"
                  size="medium"
                  checked={byIdpStatus}
                  onChange={handleBySupportToggle}
                  disabled={true}
                />
                <Typography
                  variant="body1"
                  component="span"
                >{`BlueYonder Support Login ${
                  byIdpStatus ? "Enabled" : "Disabled"
                } `}</Typography>
              </>
            ),
          }}
        />
        {/* <Box>
          <Box>
            <TableWithPaginator
              tableColumns={columns}
              tableData={allIdps.data || []}
              tableId="admins-table"
              labelRowsPerPage={LABELS.ROWS_PER_PAGE_LABEL}
              rowsPerPageOptions={PAGE_OPTIONS}
              count={allIdps.metaData?.totalCount}
              tableHeight={555}
              paging={true}
            />
          </Box>
        </Box> */}
      </Box>
    </Box>
  );
};

export default RealmIdps;
